import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SIGN_FORM_GDPR_RADIO_REMOVAL_EXPERIMENT = defineFcm('sign_form_gdpr_radio_removal_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ experimentName: undefined })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'petition page',
		description:
			'Experiment Service experiment name for the sign form GDPR radio removal experiment, and its own ' +
			'enablement flag: an unset/empty value means the experiment does not run. No merging across ' +
			'scopes — whichever of locale, country or global has an entry wins the whole value (locale beats ' +
			'country beats global), so a country or locale entry is fully independent of any other scope’s ' +
			'entry, including the global one; there is no single kill switch that reaches an ' +
			'already-configured scope. It has no default, so no scope runs until an experimentName is set for ' +
			'it or for a broader scope it falls back to. ' +
			'It is also the `?exo.<name>=<variation>` override key, which therefore changes with each iteration.',
		template: { experimentName: '' },
	});
